<div style="background-color: white;
padding: 1px 1px 1px 1px;">
<div class="content content--compact overflow-x-auto" style="grid-gap:30px 0px;margin-bottom:20px;">
    <h2 style="margin-top: 3px;">Standard Services and Pricing</h2>
    <h3>PRICING FOR RAW CARD GRADING, REHOLDERS, CROSSOVERS, AND REVIEWS</h3>
    <ejs-tab id="tab_default" (selecting)="select($event)">
        <e-tabitems>
            <e-tabitem [header]='headerText[0]' class="content content--compact overflow-x-auto">
                <ng-template #content>
                    <h3>Pricing for Standard Size Raw Card Grading, Crossovers and Reviews</h3>

                    <!-- <h4 style="text-transform:none;">

                        Please Note: Any intact SGC Pre-Graded card may be submitted for an official grade at a 40% discount. To receive the discount, please be sure to select the "Pre-Grade Encapsulation" option from the “Select Card Services” dropdown during the submission process.

                    </h4> -->
                    <div style="padding-left:10%;padding-right:10%;">
                        <ejs-grid #grid [dataSource]='dataStandardRawCard' [gridLines]="lines" allowTextWrap='true' [textWrapSettings]='wrapSettings' (queryCellInfo)='customiseCellRawCard($event)'>
                            <e-columns>
                                <e-column field='DECVALUE' headerText='DECLARED VALUE' textAlign='Center' width='150' style="padding: 20px 0;" ></e-column>
                                <!--<e-column field='TotalCards' headerText='Total Cards On Order' textAlign='Center' width='150'></e-column>-->
                                <e-column textAlign='Center' headerText='Estimated Business Days' style="color: black;
                                font-family: 'd77'; font-size: 18px;" [columns]='StdColumns'  width='150' style="padding: 20px 0;"></e-column>
                                <!--<e-column field='25' headerText='20-25 Estimated Business Days' textAlign='Center' width='100'></e-column>
                        <e-column field='10' headerText='10 Estimated Business Days' textAlign='Center' width='100'></e-column>
                        <e-column field='5' headerText='5 Estimated Business Days' textAlign='Center' width='100'></e-column>
                        <e-column field='2' headerText='1-2 Estimated Business Days' textAlign='Center' width='100'></e-column>-->
                            </e-columns>
                        </ejs-grid>
                    </div>
                    <section id="base-pricing" style="margin-top:20px;">
                        <div class="grid-list">
                            <div class="grid-list__note">
                                <!-- <p>* Due to a significant increase in submission volumes, SGC has temporarily extended its estimated turnaround time to 15-20 business days</p> -->
                                <p>** For each additional $10,000 over $100,000 in card value, add $375 to the base fee.</p>
                                <p class="bulletDisplay">
                                    <span class="bulletListTab">-</span>
                                    Orders will have longer turnaround times if Crossovers are submitted WITHOUT a minimum grade
                                </p>
                                <!--<p>Orders will be subject to longer turnaround times if:</p>
                        <p> (1) the order is submitted on a paper invoice, or</p>
                        <p> (2) a crossover is submitted WITHOUT a minimum grade, or</p>
                        <p> (3) the card requires a custom cut insert, or</p>
                        <p> (4) the research team requires additional time for the card.</p>-->
                            </div>
                        </div>
                    </section>
                    <br />
                </ng-template>
            </e-tabitem>

            <e-tabitem [header]='headerText[1]'>
                <ng-template #content>
                    <h3>PRICING FOR REHOLDERS</h3>
                    <p>
                        Reholder services are provided for SGC holders that are unopened, scratched, chipped, cracked or otherwise damaged.
                        If a holder is opened, the card must be regraded and the appropriate grading fee is due.
                    </p>
                    <div style="padding-left:10%;padding-right:10%;">
                        <ejs-grid #grid [dataSource]='dataReholder' [gridLines]="lines" allowTextWrap='true' [textWrapSettings]='wrapSettings' (queryCellInfo)='customiseCellReholder($event)'>
                            <e-columns>
                                <e-column field='DECVALUE' headerText='DECLARED VALUE' textAlign='Center' width='150'></e-column>
                                <!--<e-column field='TotalCards' headerText='Total Cards On Order' textAlign='Center' width='150'></e-column>-->
                                <e-column textAlign='Center' headerText='Estimated Business Days' [columns]='RehColumns'></e-column>
                                <!--<e-column field='25' headerText='20-25 Estimated Business Days' textAlign='Center' width='100'></e-column>
                        <e-column field='10' headerText='10 Estimated Business Days' textAlign='Center' width='100'></e-column>
                        <e-column field='5' headerText='5 Estimated Business Days' textAlign='Center' width='100'></e-column>
                        <e-column field='2' headerText='1-2 Estimated Business Days' textAlign='Center' width='100'></e-column>-->
                            </e-columns>
                        </ejs-grid>
                    </div>
                    <section id="base-pricing" style="margin-top:20px;">
                        <div class="grid-list">
                            <div class="grid-list__note">
                                <!-- <p>* Due to a significant increase in submission volumes, SGC has temporarily extended its estimated turnaround time to 15-20 business days</p> -->
                            </div>
                        </div>
                    </section>
                </ng-template>
            </e-tabitem>

            <e-tabitem [header]='headerText[2]'>
                <ng-template #content>
                    <h3>PRICING FOR OVERSIZED RAW CARD GRADING, CROSSOVERS AND REVIEWS</h3>
                    <p>Oversized items are larger than 3 ½ " x 5 ½ "</p>
                    <div style="padding-left:10%;padding-right:10%;">
                        <ejs-grid #grid [dataSource]='dataOversizedStandardRawCard' [gridLines]="lines" allowTextWrap='true' [textWrapSettings]='wrapSettings'>
                            <e-columns>
                                <e-column field='DECVALUE' headerText='DECLARED VALUE' textAlign='Center' width='150'></e-column>
                                <e-column textAlign='Center' headerText='Estimated Business Days' [columns]='StdOvrColumns'></e-column>
                                <!--<e-column field='25' headerText='20-25 Estimated Business Days' textAlign='Center' width='100'></e-column>
                        <e-column field='10' headerText='10 Estimated Business Days' textAlign='Center' width='100'></e-column>
                        <e-column field='5' headerText='5 Estimated Business Days' textAlign='Center' width='100'></e-column>
                        <e-column field='2' headerText='1-2 Estimated Business Days' textAlign='Center' width='100'></e-column>-->
                            </e-columns>
                        </ejs-grid>
                    </div>
                    <section style="margin-top:20px;">
                        <div class="grid-list">
                            <div class="grid-list__note">
                                <!-- <p>* Due to a significant increase in submission volumes, SGC has temporarily extended its estimated turnaround time to 15-20 business days</p> -->
                                <p>
                                    ** For each additional $10,000 over $100,000 in card value, add $375 to the base fee.
                                </p>
                                <p class="bulletDisplay">
                                    <span class="bulletListTab">-</span>
                                    Orders will have longer turnaround times if Crossovers are submitted without a minimum grade
                                </p>
                            </div>
                        </div>
                    </section>
                </ng-template>
            </e-tabitem>

            <e-tabitem [header]='headerText[3]'>
                <ng-template #content>
                    <h3>PRICING FOR OVERSIZED REHOLDERS</h3>
                    <p>
                        Reholder services are provided for SGC holders that are unopened, scratched, chipped, cracked or otherwise damaged.
                        If a holder is opened, the card must be regraded and the appropriate grading fee is due.
                    </p>
                    <div style="padding-left:10%;padding-right:10%;">
                        <ejs-grid #grid [dataSource]='dataOversizedReholder' [gridLines]="lines" allowTextWrap='true' [textWrapSettings]='wrapSettings'>
                            <e-columns>
                                <e-column field='DECVALUE' headerText='DECLARED VALUE' textAlign='Center' width='150'></e-column>
                                <e-column textAlign='Center' headerText='Estimated Business Days' [columns]='RehOvrColumns'></e-column>
                                <!--<e-column field='25' headerText='20-25 Estimated Business Days' textAlign='Center' width='100'></e-column>
                        <e-column field='10' headerText='10 Estimated Business Days' textAlign='Center' width='100'></e-column>
                        <e-column field='5' headerText='5 Estimated Business Days' textAlign='Center' width='100'></e-column>
                        <e-column field='2' headerText='1-2 Estimated Business Days' textAlign='Center' width='100'></e-column>-->
                            </e-columns>
                        </ejs-grid>
                    </div>
                    <section id="base-pricing" style="margin-top:20px;">
                        <div class="grid-list">
                            <div class="grid-list__note">
                                <!-- <p>* Due to a significant increase in submission volumes, SGC has temporarily extended its estimated turnaround time to 15-20 business days</p> -->
                            </div>
                        </div>
                    </section>
                </ng-template>
            </e-tabitem>

            <!--<e-tabitem [header]='headerText[4]'>
                <ng-template #content>
                    <h3>Pricing for 2022 BOWMAN CHROME SPECIAL</h3>
                    <div style="padding-left:10%;padding-right:10%;">
                        <ejs-grid #grid [dataSource]='dataBowmanCard' [gridLines]="lines" allowTextWrap='true' [textWrapSettings]='wrapSettings'>
                            <e-columns>
                                <e-column field='DECVALUE' headerText='DECLARED VALUE' textAlign='Center' width='150'></e-column>
                                <e-column textAlign='Center' headerText='Estimated Business Days' [columns]='BowmanColumns'></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </ng-template>
            </e-tabitem>-->

            <!--<e-tabitem [header]='headerText[4]'>
        <ng-template #content>
            <h3>PRICING FOR STANDARD SIZE CARDS WITH THE SGC PRE-GRADE LABEL</h3>
            <ejs-grid #grid [dataSource]='dataPreGradeCard' [gridLines]="lines" allowTextWrap='true' [textWrapSettings]='wrapSettings'>
                <e-columns>
                    <e-column field='DECVALUE' headerText='DECLARED VALUE' textAlign='Center' width='150'></e-column>
                    <e-column textAlign='Center' headerText='Estimated Business Days' [columns]='StdColumns'></e-column>
                </e-columns>
            </ejs-grid>
            <section id="base-pricing" style="margin-top:20px;">
                <div class="grid-list">
                    <div class="grid-list__note">
                        <p>** For each additional $10,000 over $100,000 in card value, add $225 to the base fee.</p>
                    </div>
                </div>
            </section>
            <br />
        </ng-template>
    </e-tabitem>-->
        </e-tabitems>
    </ejs-tab>

</div>

<!--<div class="contents content--compact overflow-x-auto" style="grid-gap:30px 0px;margin-bottom:20px;">
    <section style="margin-bottom:20px;">
        <div class="grid-list">
            <h3>ADDITIONAL UPCHARGES</h3>
            <div class="grid-list__note">
                <h4>Custom Encapsulation</h4>
                <p>Base Fee + Additional Labor: $60.00</p>
                <p>
                    All Turnaround dates are not guaranteed and will be completed based on resource availability.
                </p>
            </div>
            <div class="grid-list__note">
                <h4>Advance Research For Non-Standard Issue Cards</h4>
                <p>All Turnaround dates are not guaranteed and will be completed based on resource availability.</p>
                <p>Base Fee + Advanced Research: $60.00</p>
            </div>
        </div>
    </section>
</div>-->
</div>
